import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Footer, Header, Navbar } from "../components";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const BeasiswaPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["scholarships"],

    queryFn: async () => {
      const response = await customAxios.get("scholarships");

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderContent = () => {
    if (isLoading)
      return (
        <>
          <div className="h-[230px] w-fit flex">
            <div
              className="h-[200px] w-[334px] self-end flex flex-col 
                          justify-center content-center items-center 
                          rounded-xl shadow-[6px_8px_19px_-1px_rgba(0,0,0,0.3)]"
            >
              <div className="rounded-xl h-[140px] w-[140px] relative bottom-[35px] bg-gray-200"></div>

              <div className="relative bottom-[20px] w-full px-4 flex flex-col gap-2 items-center">
                <div className="w-full p-4 bg-gray-200 rounded"></div>
                <div className="p-2 rounded w-[80px] bg-gray-200"></div>
              </div>
            </div>
          </div>
          <div className="h-[230px] w-fit flex">
            <div
              className="h-[200px] w-[334px] self-end flex flex-col 
                          justify-center content-center items-center 
                          rounded-xl shadow-[6px_8px_19px_-1px_rgba(0,0,0,0.3)]"
            >
              <div className="rounded-xl h-[140px] w-[140px] relative bottom-[35px] bg-gray-200"></div>

              <div className="relative bottom-[20px] w-full px-4 flex flex-col gap-2 items-center">
                <div className="w-full p-4 bg-gray-200 rounded"></div>
                <div className="p-2 rounded w-[80px] bg-gray-200"></div>
              </div>
            </div>
          </div>
          <div className="h-[230px] w-fit flex">
            <div
              className="h-[200px] w-[334px] self-end flex flex-col 
                          justify-center content-center items-center 
                          rounded-xl shadow-[6px_8px_19px_-1px_rgba(0,0,0,0.3)]"
            >
              <div className="rounded-xl h-[140px] w-[140px] relative bottom-[35px] bg-gray-200"></div>

              <div className="relative bottom-[20px] w-full px-4 flex flex-col gap-2 items-center">
                <div className="w-full p-4 bg-gray-200 rounded"></div>
                <div className="p-2 rounded w-[80px] bg-gray-200"></div>
              </div>
            </div>
          </div>
        </>
      );

    // TODO: No data state
    if (!data) return null;

    return (
      <>
        {data?.map((scholarship, index) => {
          return (
            <div className="h-[230px] w-fit flex" key={index}>
              <div
                className="h-[200px] w-[334px] self-end flex flex-col 
                          justify-center content-center items-center 
                          rounded-xl shadow-[6px_8px_19px_-1px_rgba(0,0,0,0.3)]"
              >
                <div className="rounded-xl h-[140px] w-[140px] relative bottom-[35px] overflow-hidden">
                  <img
                    src={scholarship?.thumbnail}
                    alt={
                      currentLanguage === "en"
                        ? scholarship?.title_en
                        : scholarship?.title_id
                    }
                  />
                </div>

                <div className="relative text-center bottom-[20px]">
                  <p
                    className={`${styles.textM} text-center text-neutral-90 font-bold`}
                  >
                    {currentLanguage === "en"
                      ? scholarship?.title_en
                      : scholarship?.title_id}
                  </p>
                  <Link
                    to={scholarship?.slug}
                    className={`${styles.textSMedium} text-center text-warning-40 hover:underline italic pb-1`}
                  >
                    <Trans i18nKey="scholarship.details">
                      Selengkapnya &#62;
                    </Trans>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("scholarship.header")} />
      <main className={`${styles.paddingX} flex flex-wrap justify-center gap-3 py-20 min-h-[600px]`}>
        <div className="container flex flex-wrap justify-center w-full gap-x-6 gap-y-16">
          {renderContent()}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default BeasiswaPage;
